var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, DropdownSelect, HelperField, ModalBody, ModalFoot, ModalHead, Radio, SelectItem, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import * as React from 'react';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { FlowType } from 'fable/flowEditor';
import { AutomationNodeTypes, withQueues } from 'hocs';
import { getSubmitAnalyticsAction } from 'utils/flowEditor/analytics';
import styles from './shared.module.scss';
class QueueModalImp extends React.Component {
    constructor(props) {
        super(props);
        const { node } = props;
        const payload = node.nodeType === AutomationNodeTypes.QUEUE
            ? node.payload
            : {
                transferToQueueId: null,
                queueName: null,
            };
        this.state = {
            shouldTransfer: payload.transferToQueueId !== null,
            validation: {},
            payload: node.nodeType === AutomationNodeTypes.QUEUE ? node.payload : payload,
        };
    }
    componentDidMount() {
        const { queues } = this.props;
        return queues.getItems();
    }
    handleAnalytics() {
        const { node } = this.props;
        const { payload } = this.state;
        const analyticsAction = getSubmitAnalyticsAction(!!node.isAction);
        analyticsAction({
            flowType: FlowType.FLOW_TYPE_AUTOMATION,
            nodeType: AutomationNodeTypes.QUEUE,
            settings: {
                transferToQueue: !!payload.transferToQueueId,
            },
        });
    }
    handleConfirm() {
        const errors = this.validate();
        if (Object.keys(errors).length > 0) {
            this.setState({ validation: errors });
            return;
        }
        this.saveNode();
    }
    saveNode() {
        const { replaceNode } = this.props;
        const { payload } = this.state;
        this.handleAnalytics();
        const nodeOptions = Object.assign(Object.assign({}, this.props.node), { nodeType: AutomationNodeTypes.QUEUE, isAction: false, isRemovable: true, isEditable: true, payload });
        replaceNode(nodeOptions);
        this.closeModal();
    }
    closeModal() {
        this.props.triggerClose();
    }
    radioOnChange(evt) {
        const option = evt.target.id;
        const shouldTransfer = option === 'transfer';
        const { payload } = this.state;
        this.setState({
            shouldTransfer,
            payload: {
                transferToQueueId: null,
                queueName: shouldTransfer ? payload.queueName : null,
            },
        });
    }
    getQueueOptions() {
        return this.props.queues.items;
    }
    getActiveQueueId() {
        return this.state.payload.transferToQueueId;
    }
    getPagination() {
        const { queues } = this.props;
        return {
            nextEnable: queues.hasNextPage,
            onNext: queues.nextPage,
            previousEnable: queues.hasPreviousPage,
            onPrevious: queues.previousPage,
        };
    }
    onQueueSearch(searchTerm) {
        const { queues } = this.props;
        if (searchTerm !== undefined && searchTerm !== queues.searchTerm) {
            queues.searchTermChange(searchTerm);
        }
    }
    onQueueSelect(queue) {
        this.setState({
            shouldTransfer: true,
            validation: {},
            payload: {
                transferToQueueId: queue.id,
                queueName: queue.name,
            },
        });
    }
    validate() {
        const errors = {};
        const { shouldTransfer, payload } = this.state;
        if (shouldTransfer && !payload.transferToQueueId) {
            errors.queue = 'Please select a queue';
        }
        return errors;
    }
    render() {
        var _a, _b, _c;
        const { shouldTransfer, payload, validation } = this.state;
        const { node, nodeLabel } = this.props;
        const isChanged = payload.transferToQueueId !== ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.transferToQueueId) ||
            payload.queueName !== ((_b = node.payload) === null || _b === void 0 ? void 0 : _b.queueName);
        return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal }, { children: "Re-offer conversation to the original queue or move it to a different queue." })), _jsx(ModalBody, { children: _jsxs(Box, { children: [_jsxs("label", Object.assign({ className: styles.optionLabel }, { children: [_jsx(Radio, { id: "requeue", name: "shouldTransfer", checked: !shouldTransfer, onChange: this.radioOnChange }), "Re-offer conversation to original queue"] })), _jsxs("label", Object.assign({ className: styles.optionLabel }, { children: [_jsx(Radio, { id: "transfer", name: "shouldTransfer", checked: shouldTransfer, onChange: this.radioOnChange }), "Move to queue"] })), _jsx(HelperField, Object.assign({ fieldId: "queue", label: "Select queue", errorMessage: validation.queue, required: shouldTransfer }, { children: _jsx(_Fragment, {}) })), _jsx(DropdownSelect, Object.assign({ containerProps: { className: styles.dropdownContainer }, buttonProps: {
                                    disabled: !shouldTransfer,
                                }, itemComponent: SelectItem, items: this.getQueueOptions(), activeItem: this.getActiveQueueId(), hasSearch: true, pagination: this.getPagination(), onSearch: this.onQueueSearch, onSelect: this.onQueueSelect }, { children: (_c = payload.queueName) !== null && _c !== void 0 ? _c : 'Select queue' }))] }) }), _jsx(ModalFoot, { confirmOnClick: this.handleConfirm, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.closeModal })] })));
    }
}
__decorate([
    boundMethod
], QueueModalImp.prototype, "handleConfirm", null);
__decorate([
    boundMethod
], QueueModalImp.prototype, "closeModal", null);
__decorate([
    boundMethod
], QueueModalImp.prototype, "radioOnChange", null);
__decorate([
    boundMethod
], QueueModalImp.prototype, "onQueueSearch", null);
__decorate([
    boundMethod
], QueueModalImp.prototype, "onQueueSelect", null);
export const QueueModal = withQueues(QueueModalImp);
